export default function (Component) {
  const _Component = Component
  _Component.__i18n = _Component.__i18n || []
  _Component.__i18n.push({
    "locale": "",
    "resource": {
      "en": {
        "name_en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (English)"])},
        "name_fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Name (French)"])},
        "default_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default Role?"])},
        "requestable_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Requestable Role?"])},
        "nalbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Features"])},
        "default_nalb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Default"])}
      },
      "fr": {
        "name_en": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Anglais)"])},
        "name_fr": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Nom (Français)"])},
        "default_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle par défaut?"])},
        "requestable_role": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Rôle requis?"])},
        "nalbs": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["traits"])},
        "default_nalb": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["Défaut"])}
      }
    }
  })
}